import _toConsumableArray from "/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/toConsumableArray";
import _Set from "/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/set";

export var state = function state() {
  return {
    bulkyRegUserList: [],
    bulkyCreateMsList: [],
    languages: [],
    moduleNames: [],
    mIsLoading: false
  };
};

export var mutations = {
  setBulkyRegUserList: function setBulkyRegUserList(state, bulkyRegUser) {
    // let tempArr = state.bulkyRegUserList;
    // tempArr = tempArr.push(bulkyRegUser);
    // state.bulkyRegUserList = [...tempArr];
    state.bulkyRegUserList.push(bulkyRegUser);
  },
  clearBulkyCreateMsList: function clearBulkyCreateMsList(state) {
    state.bulkyCreateMsList = [];
  },
  addBulkyCreateMsList: function addBulkyCreateMsList(state, _ref) {
    var dataReturned = _ref.dataReturned;

    // const tempArr = {...dataReturned};
    // state.bulkyCreateMsList = JSON.parse(JSON.stringify(dataReturned));
    state.bulkyCreateMsList.push(dataReturned);
    // dataReturned.forEach((data)=> {
    //   state.bulkyCreateMsList.push(data);
    // });
  },
  setLang: function setLang(state, languages) {
    state.languages = languages;
  },
  removeLang: function removeLang(state, language) {
    var tempList = new _Set(state.languages);
    tempList.delete(language);
    state.languages = [].concat(_toConsumableArray(tempList));
  },
  setModuleName: function setModuleName(state, moduleNames) {
    state.moduleNames = moduleNames;
  },
  addNewModule: function addNewModule(state, _ref2) {
    var moduleName = _ref2.moduleName;

    state.moduleNames.push(moduleName);
  },
  removeModuleName: function removeModuleName(state, moduleName) {
    var tempList = new _Set(state.moduleNames);
    tempList.delete(moduleName);
    state.moduleNames = [].concat(_toConsumableArray(tempList));
  },
  setMisLoading: function setMisLoading(state, isLoading) {
    state.mIsLoading = isLoading;
  }
};


//////////////////
// WEBPACK FOOTER
// ./store/management.js
// module id = ./store/management.js
// module chunks = 20